// Keep the desktop header menu on one line: items that do not fit move into a "More" dropdown.
(() => {
  const nav = document.querySelector('.header__inline-menu');
  const list = nav && nav.querySelector(':scope > .list-menu--inline');
  if (!list) return;
  const items = [...list.children].filter((li) => li.dataset.prUrl);
  if (!items.length) return;

  const more = document.createElement('li');
  more.className = 'pr-more';
  more.innerHTML =
    '<details class="pr-more__details"><summary class="header__menu-item list-menu__item link focus-inset"><span>More</span></summary>' +
    '<ul class="pr-more__list" role="list"></ul></details>';
  list.appendChild(more);
  const moreList = more.querySelector('.pr-more__list');
  const details = more.querySelector('details');

  const fit = () => {
    items.forEach((li) => (li.hidden = false));
    more.hidden = true;
    moreList.innerHTML = '';
    if (getComputedStyle(nav).display === 'none') return;
    const max = nav.clientWidth;
    if (list.scrollWidth <= max + 1) return;
    more.hidden = false;
    const hidden = [];
    for (let i = items.length - 1; i >= 0 && list.scrollWidth > max + 1; i--) {
      items[i].hidden = true;
      hidden.unshift(items[i]);
    }
    hidden.forEach((li) => {
      const a = document.createElement('a');
      a.href = li.dataset.prUrl;
      a.textContent = li.dataset.prTitle;
      const row = document.createElement('li');
      row.appendChild(a);
      moreList.appendChild(row);
    });
  };

  let t;
  addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(fit, 120);
  });
  document.addEventListener('click', (e) => {
    if (!more.contains(e.target)) details.removeAttribute('open');
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  fit();
})();
